import { Movimiento } from 'core/tarjeta/models/Movimiento';
import { MovimientosRubro } from 'core/tarjeta/models/MovimientosRubro';
import { Rubro } from 'core/tarjeta/models/Rubro';
import { Pageable } from 'shared/table/models/Pageable';
import { formatPeriodo } from 'shared/utils';
import { CardMovementsTableWithPagination } from 'core/tarjeta/components/CardMovementsTableWithPagination/CardMovementsTableWithPagination';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { PageTitle } from 'shared/components/Fonts';

export const CardMovementsList = (props: {
  searchParams: URLSearchParams;
  groupByCategory(rubroId?: number): void;
  movimientosRubro: MovimientosRubro[];
  rubros: Rubro[];
  movimientos: Pageable<Movimiento>;
}) => {
  const searchPeriodo = formatPeriodo(props.searchParams);
  const handleChange = (e) => {
    const selected = e.target.selectedIndex;
    if (selected > 0) {
      let rubro = e.target.value;
      props.groupByCategory(rubro);
    }
  };

  return (
    <>
      {props.movimientosRubro ? (
        props.movimientosRubro.map((movimientoRubro) => (
          <div key={movimientoRubro.rubro}>
            <PageTitle>Rubro: {movimientoRubro.rubro}</PageTitle>
            <CardMovementsTableWithPagination
              movimientos={movimientoRubro.movimientos}
              rubroId={movimientoRubro.rubroId}
              periodo={searchPeriodo}
            />
          </div>
        ))
      ) : (
        <>
          <Row className="mb-3">
            <Col className="text-end">
              <Button
                variant="secondary"
                type="button"
                onClick={() => props.groupByCategory()}
              >
                Agrupar por rubros
              </Button>
            </Col>
            <Col xs={4}>
              <InputGroup>
                <InputGroup.Text>Filtrar por</InputGroup.Text>
                <Form.Select data-testid="test-select-rubro" onChange={handleChange}>
                  <option value="default" key="default">
                    Seleccione una opción
                  </option>
                  {props.rubros.map((rubro) => (
                    <option value={rubro.id} key={'opt-' + rubro.id}>
                      {rubro.nombre}
                    </option>
                  ))}
                </Form.Select>
              </InputGroup>
            </Col>
          </Row>
          <CardMovementsTableWithPagination
            movimientos={props.movimientos}
            periodo={searchPeriodo}
          ></CardMovementsTableWithPagination>
        </>
      )}
    </>
  );
};
